module.exports = __webpack_public_path__ + "img/7-1@2x.f48fcd54.png";